module.exports = __webpack_public_path__ + "img/39_64.47c06689.png";